import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import type { NotificationSettings } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onSuccess?: (notificationSettings: NotificationSettings) => void
  children?: (response: NotificationSettings) => ReactElement | boolean
}

const GetNotificationSettingsRequest = ({
  onSuccess,
  children
}: Props) => {
  const url = `${NOTIFICATION_SERVICE}/settings`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetNotificationSettingsRequest
